// extracted by mini-css-extract-plugin
export var integrationButton = "_b7-0";